module.exports = __webpack_public_path__ + "static/media/aleksandar_gakovic.d5a0313e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/aleksandar_gakovic.jpg
// module id = 426
// module chunks = 0